/* eslint-disable @typescript-eslint/no-magic-numbers */
function isGenitivePlural(number) {
    return ((number > 10 && (number % 100) - ((number % 100) % 10) === 10) ||
        number % 10 === 0 ||
        number % 10 >= 5);
}
function isGenitiveSingular(number) {
    return Math.floor(number) !== number || number % 10 >= 2;
}
function createPluralize(word, singular, plural) {
    return (number) => {
        const abs = Math.abs(number);
        if (abs === 1)
            return `${number} ${word}`;
        if (!plural)
            return `${number} ${singular}`;
        if (isGenitivePlural(abs))
            return `${number} ${plural}`;
        if (isGenitiveSingular(abs))
            return `${number} ${singular}`;
        return `${number} ${word}`;
    };
}
// eslint-disable-next-line max-params, sonarjs/function-return-type
export function pluralize(number, word, singular, plural) {
    return typeof number === 'number'
        ? createPluralize(word, singular, plural)(number)
        : createPluralize(number, word, singular);
}
